import { Button, DatePicker, Dropdown, Input } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { BiSearch, BiX, BiZoomOut } from "react-icons/bi";
import { FiClock } from "react-icons/fi";

export const AlarmTimeFilter = ({ getAlarmCounter }) => {
  const ref = useRef();
  const timeInputRef = useRef();
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateShow, setStartDateShow] = useState("");
  const [endDateShow, setEndDateShow] = useState("");
  const [quickStartDate, setQuickStartDate] = useState("");
  const [quickEndDate, setQuickEndDate] = useState("");
  const [xAxis, setXAxis] = useState("day");

  const [timeOptions, setTimeoptions] = useState(quickTimeOption);
  const onSerchTimeOption = (e) => {
    const search = quickTimeOption.filter((tm) => tm.label.includes(e.target.value));
    setTimeoptions(search);
  };
  const onApply = () => {
    setOpen(false);
    let firstDate = startDate.format("YYYY/MM/DD : HH:mm");
    let lastDate = endDate.format("YYYY/MM/DD : HH:mm");
    getAlarmCounter({
      startDate: firstDate,
      endDate: lastDate,
    });
    setStartDateShow(firstDate);
    setEndDateShow(lastDate);
    setQuickStartDate("");
    setQuickEndDate("");
    setXAxis("day");
  };
  const onSelectQuickTimer = ({ value, durationType }) => {
    let firstDate = moment().subtract(durationType, value).format("YYYY/MM/DD : HH:mm");
    let lastDate = moment().format("YYYY/MM/DD : HH:mm");
    getAlarmCounter({
      startDate: firstDate,
      endDate: lastDate,
    });
    setStartDate("");
    setEndDate("");
    setStartDateShow("");
    setEndDateShow("");
    setQuickStartDate(firstDate);
    setQuickEndDate(lastDate);
    setXAxis(durationType);
    setOpen(false);
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    setStartDateShow("");
    setEndDateShow("");
    setXAxis("");
    setQuickStartDate("");
    setQuickEndDate("");
    getAlarmCounter();
  };

  const handleZoomOut = () => {
    if (quickStartDate && quickEndDate) {
      let start = moment(quickStartDate, "YYYY/MM/DD : HH:mm").subtract(1, xAxis).format("YYYY/MM/DD : HH:mm");
      let end =
        moment(quickEndDate, "YYYY/MM/DD : HH:mm").add(1, xAxis) < moment()
          ? moment(quickEndDate, "YYYY/MM/DD : HH:mm").add(1, xAxis).format("YYYY/MM/DD : HH:mm")
          : moment().format("YYYY/MM/DD : HH:mm");
      // moment(quickEndDate, "YYYY/MM/DD : HH:mm").add(1, xAxis).format("YYYY/MM/DD : HH:mm");
      getAlarmCounter({
        startDate: start,
        endDate: end,
      });
      setQuickStartDate(start);
      setQuickEndDate(end);
    } else if (startDateShow && endDateShow) {
      let start = moment(startDateShow, "YYYY/MM/DD : HH:mm").subtract(1, xAxis).format("YYYY/MM/DD : HH:mm");
      let end =
        moment(endDateShow, "YYYY/MM/DD : HH:mm").add(1, xAxis) < moment()
          ? moment(endDateShow, "YYYY/MM/DD : HH:mm").add(1, xAxis).format("YYYY/MM/DD : HH:mm")
          : moment().format("YYYY/MM/DD : HH:mm");
      // moment(endDateShow, "YYYY/MM/DD : HH:mm").add(1, xAxis).format("YYYY/MM/DD : HH:mm");
      getAlarmCounter({
        startDate: start,
        endDate: end,
      });
      setStartDateShow(start);
      setEndDateShow(end);
    }
  };

  const currentSelectTime = () => {
    if (startDateShow) {
      return `${startDateShow} - ${endDateShow}`;
    } else if (quickStartDate) {
      return `${quickStartDate} - ${quickEndDate}`;
    } else {
      return "Last 7 Days";
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (timeInputRef.current && !timeInputRef.current.contains(event.target)) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="d-flex align-items-center" style={{ marginBottom: "-8px" }}>
      {(startDateShow || quickStartDate) && (
        <div
          className="mr-2 rounded-2 bg-primary"
          style={{
            background: "red",
            fontSize: "19px",
            color: "#fff",
            padding: "0px 5px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={handleClear}
        >
          <BiX style={{ marginBottom: "4px" }} />
        </div>
      )}
      <div ref={ref} className="d-flex bg-primary text-white overflow-hidden rounded-2">
        <Dropdown
          placement="topLeft"
          overlayClassName="time-dropdown"
          className="bg-transparent text-white border-0"
          open={open}
          getPopupContainer={(triggerNode) => triggerNode}
          menu={{
            items: [
              {
                key: "0",
                disabled: true,
                label: (
                  <div
                    style={{
                      width: "100%",
                      maxWidth: 500,
                    }}
                  >
                    <div className="d-flex justify-content-end mb-3" style={{ fontSize: "18px" }}>
                      <Modal.Header className="text-right" closeButton onClick={() => setOpen(false)} />
                    </div>
                    <Row className="g-3">
                      <Col xs={12} md={7}>
                        <h6 className="mb-3">Absolute Time Range</h6>
                        <div className="mb-2 time-input">
                          <label className="fw-bold">From</label>
                          <div ref={timeInputRef}>
                            <DatePicker
                              onChange={(value) => setStartDate(value)}
                              value={startDate ? startDate : ""}
                              disabledDate={(current) => current && current.valueOf() > new Date()}
                              size="large"
                              className="w-100"
                              getPopupContainer={(triggerNode) => triggerNode}
                              placement="topLeft"
                            />
                          </div>
                        </div>
                        <div className="mb-4 time-input">
                          <label className="fw-bold">To</label>
                          <div ref={timeInputRef}>
                            <DatePicker
                              disabled={!startDate}
                              value={endDate ? endDate : ""}
                              onChange={(value) => setEndDate(value)}
                              disabledDate={(current) =>
                                current && (current.valueOf() < startDate || current.valueOf() > new Date())
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                              size="large"
                              className="w-100"
                              placement="topLeft"
                            />
                          </div>
                        </div>
                        <button disabled={!startDate || !endDate} onClick={onApply} className="btn btn-success">
                          Apply
                        </button>
                      </Col>
                      <Col xs={12} md={5} className="alarmFilterDivider">
                        <div className="time-input">
                          <Input
                            size="middle"
                            placeholder="Search quick ranges"
                            prefix={<BiSearch />}
                            onChange={onSerchTimeOption}
                            className="w-100"
                          />
                        </div>
                        <div className="my-3 quick-time-option">
                          {timeOptions.map((time) => (
                            <Button
                              style={{ display: "block", fontWeight: "500" }}
                              type="text"
                              onClick={() => onSelectQuickTimer(time)}
                              key={time?.label}
                            >
                              {time?.label}
                            </Button>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  </div>
                ),
              },
            ],
          }}
          trigger={["click"]}
        >
          <div
            className="d-flex align-items-center bg_light_gray"
            style={{
              padding: "5px 10px",
              border: "1px solid  var(--color_light)",
              fontSize: "14px",
            }}
            onClick={() => setOpen(!open)}
          >
            <FiClock className="mr-2" fontSize="14px" />
            <span className="mr-2">{currentSelectTime()}</span>
          </div>
        </Dropdown>
        <button
          // className="bg_light_gray"
          className="bg-transparent text-white"
          style={{
            // padding: "3px 10px",
            border: "none",
          }}
          onClick={handleZoomOut}
        >
          <BiZoomOut fontSize="18px" />
        </button>
      </div>
    </div>
  );
};

export default AlarmTimeFilter;

const quickTimeOption = [
  { label: "Last 5 minutes", value: 5, durationType: "minute" },
  { label: "Last 15 minutes", value: 15, durationType: "minute" },
  { label: "Last 30 minutes", value: 30, durationType: "minute" },
  { label: "Last 1 hours", value: 1, durationType: "hour" },
  { label: "Last 3 hours", value: 3, durationType: "hour" },
  { label: "Last 6 hours", value: 6, durationType: "hour" },
  { label: "Last 12 hours", value: 12, durationType: "hour" },
  { label: "Last 24 hours", value: 24, durationType: "hour" },
  { label: "Last 2 days", value: 2, durationType: "day" },
  { label: "Last 3 days", value: 3, durationType: "day" },
  { label: "Last 7 days", value: 7, durationType: "day" },
  { label: "Last 30 days", value: 30, durationType: "day" },
  { label: "Last 3 months", value: 3, durationType: "month" },
  { label: "Last 6 months", value: 6, durationType: "month" },
  { label: "Last 12 months", value: 12, durationType: "month" },
];

AlarmTimeFilter.propTypes = {
  getAlarmCounter: PropTypes.func,
};
